var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container",class:[_vm.type],on:{"click":_vm.onClick}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }